module.exports = __webpack_public_path__ + "static/media/support-instagram.64f9bb38.png";